import { Icon } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { TranslationsKeys } from '../../../../../locales/translations';

interface ReportHistoryCellProps {
  lastGeneratedDate?: string;
  lastGeneratedUrl?: string;
  generatedBy?: string;
  periodOrBreakDate?: string;
}

const ReportHistoryCell = ({
  lastGeneratedDate,
  lastGeneratedUrl,
  generatedBy,
  periodOrBreakDate,
}: ReportHistoryCellProps) => {
  const { t } = useTranslation(TranslationsKeys.MANAGEMENT_TOOLS_REPORTS_ASYNC);

  if (!lastGeneratedUrl) {
    return <span>{t('table.noReports')}</span>;
  }

  return (
    <a
      href={lastGeneratedUrl}
      rel="noreferrer"
      target="_blank"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 5,
        textDecoration: 'none',
        flexDirection: 'column',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
        <strong className="text-dark">
          {dayjs(lastGeneratedDate).format('DD/MM/YY [-] HH:mm')}
        </strong>
        <Icon name="download" />
      </div>
      {(generatedBy || periodOrBreakDate) && (
        <div
          style={{
            fontSize: '11px',
            color: '#666',
            display: 'flex',
            alignItems: 'center',
            gap: 4,
          }}
        >
          {generatedBy && <span>por {generatedBy}</span>}
          {generatedBy && periodOrBreakDate && <span>•</span>}
          {periodOrBreakDate && (
            <span>
              {t('table.historyPeriod')}: {periodOrBreakDate}
            </span>
          )}
        </div>
      )}
    </a>
  );
};

export default ReportHistoryCell;
